import React, { useState } from 'react'
import { connect } from 'react-redux'
import {
  getValue,
  isModalOpen,
  getStatusOfDMS
} from '../../store/actions'
import api from '../../api'
import BaseCheckbox from '../BaseCheckbox'
import BaseModal from '../BaseModal'
import ButtonPrimary from '../ui/ButtonPrimary'

import './index.css'
import ButtonTransparent from '../ui/ButtonTransparent'

const ModalJob = props => {


  const [ checkedItems, setCheckedItems ] = useState([])

  const checkboxOnClick = (item, i) => {
    if (!checkedItems.includes(i)) {
      setCheckedItems([ ...checkedItems, i ])
    }
    if (checkedItems.length === 4) {
      const newArray = checkedItems
      const valueToRemove = i
      const filteredItems = newArray.filter(item => item !== valueToRemove)
      setCheckedItems(filteredItems)
    }
  }

  const handleClick = async () => {
    props.setIsJobModalOpen(false)
    props.setIsStatusModalOpen(true)
    await api.pushDataToDms(props.id)
    await props.getStatusOfDMS(props.id)

  }
  const handleClickButtonSecondary = () => {
    props.setIsJobModalOpen(false)
  }
  const body = (
    <div className="info-modal__filter">
      <h2 className="info-modal__title">Before Completing Job</h2>
      <div>
        {props.tasks && props.tasks.map((item, i) => (
          <div className='job-modal'>
            <BaseCheckbox
              checkboxId={i}
              onCheck={() => checkboxOnClick(item, i)}
            />
            <p key={`row-${i}`}>{item}</p>
          </div>
        ))}
      </div>
    </div>
  )
  const footer = (
    <div className="variance-list-modal__form-group variance-list-modal__controls variance-list-modal__footer">
      <ButtonPrimary isDisabled={checkedItems.length !== 4} name="Complete" onClick={handleClick} />
      <ButtonTransparent name='Cancel' onClick={handleClickButtonSecondary} />
    </div>
  )
  return (
    <BaseModal
      onClose={handleClickButtonSecondary}
      body={body}
      footer={footer}
    />
  )
}

const mapStateToProps = ({ data: { value, open, tasks } }) => ({ value, open, tasks })
const mapDispatchToProps = ({ getValue, isModalOpen,getStatusOfDMS })

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalJob)




